import { NDFL3DefaultLogic } from './NDFL3DefaultLogic';
import NDFL3YearLogic2015 from './NDFL3YearLogic2015';
import NDFL3YearLogic2017 from './NDFL3YearLogic2017';
import NDFL3YearLogic2018 from './NDFL3YearLogic2018';
import NDFL3YearLogic2019 from './NDFL3YearLogic2019';
import NDFL3YearLogic2020 from './NDFL3YearLogic2020';
import NDFL3YearLogic2021 from './NDFL3YearLogic2021';

let NDFL3YearLogic = { logic: new NDFL3DefaultLogic() };

/**
 * @param {number} year
 *
 * @todo: monkey-patching, replace with React context api
 */
export function setNDFL3YearLogic(year) {
  switch (year) {
    case 2021: {
      NDFL3YearLogic.logic = new NDFL3YearLogic2021();
      break;
    }
    case 2020: {
      NDFL3YearLogic.logic = new NDFL3YearLogic2020();
      break;
    }
    case 2019: {
      NDFL3YearLogic.logic = new NDFL3YearLogic2019();
      break;
    }
    case 2018: {
      NDFL3YearLogic.logic = new NDFL3YearLogic2018();
      break;
    }
    case 2017: {
      NDFL3YearLogic.logic = new NDFL3YearLogic2017();
      break;
    }
    case 2015: {
      NDFL3YearLogic.logic = new NDFL3YearLogic2015();
      break;
    }
    default:
      NDFL3YearLogic.logic = new NDFL3DefaultLogic();
  }
}

export default NDFL3YearLogic;
